"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThemeTokenDataGroups = void 0;
var index_1 = require("../index");
var types_1 = require("../types");
var isTokenData = function (value) {
    return typeof value === 'object' && value !== null && 'value' in value;
};
var makePath = function (path, key) {
    if (!path && key in types_1.TokenGroup) {
        return '';
    }
    if (path === types_1.TokenMode.default) {
        return key;
    }
    return path ? "".concat(path).concat((0, index_1.upperFirstLetter)(key)) : key;
};
var dataObjectToTokenDataGroup = function (dataObject, path, prefix) {
    return Object.entries(dataObject).reduce(function (acc, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        var fullPath = makePath(path, key);
        if (isTokenData(value) && value.enabled === false) {
            return acc;
        }
        if (isTokenData(value)) {
            var tokenName = prefix ? "".concat(prefix).concat((0, index_1.upperFirstLetter)(fullPath)) : fullPath;
            return __assign(__assign({}, acc), (_b = {}, _b[tokenName] = value, _b));
        }
        if (value && typeof value === 'object') {
            return __assign(__assign({}, acc), dataObjectToTokenDataGroup(value, fullPath, prefix));
        }
        return acc;
    }, {});
};
var getThemeTokenDataGroups = function (theme) {
    var _a, _b;
    var name = theme.config.name, dark = theme.dark, light = theme.light, shadow = theme.shadow, borderRadius = theme.borderRadius, spacing = theme.spacing;
    var shadowTokens = shadow
        ? dataObjectToTokenDataGroup(shadow, '', 'shadow')
        : undefined;
    var borderRadiusTokens = borderRadius
        ? dataObjectToTokenDataGroup(borderRadius, '', 'borderRadius')
        : undefined;
    var spacingTokens = spacing
        ? dataObjectToTokenDataGroup(spacing, '', 'spacing')
        : undefined;
    return _a = {},
        _a[name] = (_b = {},
            _b["".concat(name, "__dark")] = {
                color: dataObjectToTokenDataGroup(dark, ''),
                shadow: shadowTokens,
                borderRadius: borderRadiusTokens,
                spacing: spacingTokens,
            },
            _b["".concat(name, "__light")] = {
                color: dataObjectToTokenDataGroup(light, ''),
                shadow: shadowTokens,
                borderRadius: borderRadiusTokens,
                spacing: spacingTokens,
            },
            _b),
        _a;
};
exports.getThemeTokenDataGroups = getThemeTokenDataGroups;
//# sourceMappingURL=getThemeTokenDataGroups.js.map